import { styled } from '@mui/material'
import ListItemButton from '@mui/material/ListItemButton'

export const StyledListItemButton = styled(ListItemButton)({
  '& > svg': {
    paddingRight: '1rem',
  },
})
